module.exports = __webpack_public_path__ + "img/dnatestingsanfrancisco.c4913283.png";